import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f2a4b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-5 justify-items-stretch items-center gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "justify-center items-center col-span-5",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)\n          rgb(235, 239, 240)","border-radius":"5px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Bilder hinzugefügt", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "flex item-stretch justify-center items-center",
  style: {"height":"150px","max-height":"150px","background-color":"rgb(235, 239, 240)","border-radius":"5px","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)\n            rgb(235, 239, 240)"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center self-center" }, "Kein Bild hinzugefügt", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.areImagesTaken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.arrayWithFiveElementsAndImages, (imgObj) => {
          return (_openBlock(), _createElementBlock("div", {
            key: imgObj,
            class: "flex item-stretch justify-center items-center",
            style: {"height":"150px","max-height":"150px","border-radius":"5px","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)\n          rgb(235, 239, 240)","background-color":"rgb(235, 239, 240)"}
          }, [
            (_ctx.getPhotoUrl(imgObj))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getPhotoUrl(imgObj),
                  "data-cy": "image",
                  style: {"height":"150px","max-height":"150px"},
                  class: "self-center"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          ]))
        }), 128))
  ]))
}